module.exports = __webpack_public_path__ + "67bc4509460a920578afe0e75aca2103.png";